import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { PurchaseOrder } from 'src/api/types/PurchaseOrder';
import { MappedSKU } from 'src/api/types/Skus';

// ----------------------------------------------------------------------

type RouterState = {
  filter?: string | MappedSKU;
  createSimilar?: PurchaseOrder;
  createForSKU?: MappedSKU | Record<string, unknown>;
  createForSKUs?: MappedSKU[] | Record<string, unknown>[];
};

export function useRouter() {
  const navigate = useNavigate();

  const router = useMemo(
    () => ({
      back: () => navigate(-1),
      forward: () => navigate(1),
      reload: () => window.location.reload(),
      push: (href: string, options?: { state?: RouterState }) => navigate(href, options),
      replace: (href: string) => navigate(href, { replace: true }),
    }),
    [navigate]
  );

  return router;
}
